module.exports = __webpack_public_path__ + "static/media/blue-arrow-spinner.dce32ad4.gif";